export enum TTS_MODE {
  SPEAK_ALL = 0,
  VOCABULARY = 1,
}
